import React, { useState, useEffect } from 'react';
import { default as useRequest } from "@pb/utils/reactHooks/useRequest";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { default as useGetLabels } from "@pb/utils/labels/useGetLabels";
import { isArketBrand } from "@pb/utils/brandConfig";
import { isMonkiBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import ModalButtons from "../../helpers/ModalButtons";
import { Button } from "../../ui/CTA";
import IconButton from "../../ui/CTA/IconButton";
import HeartIcon from "../../ui/Icon/HmIcons/HeartIcon";
import Modal from "../../ui/Modal";
import BodyText from "../../ui/Typography/texts/BodyText";
import styles from './FavouritesButton.module.scss';
import { defaultFavouriteLabels } from './helpers/favouriteLabels';
import { trackFavouriteToggle } from './helpers/tracking';
import { normalizeFavouriteTrackingInfo } from './helpers/trackingNormalizor';
const FavouritesButton = ({ favouritesProducts = [], articleCode, withBackground = false, isModalCompressed = false, customTrackingData = {}, favouritesLabels = {}, className, size, shouldOverlay, onFavouritesClick = () => { }, isAltFavouritesClick = false, isFavouriteSizeVariant = false, disableFavouriteDefaultLabels = false, isCompareArticleIdOnly = false, }) => {
    const [isFavourite, setIsFavourite] = useState(false);
    const [modal, setModal] = useState({ show: false, text: '', title: '' });
    // Disable lint as added props to prevent get labels api call
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (!disableFavouriteDefaultLabels)
        useGetLabels();
    const defaultLabels = !disableFavouriteDefaultLabels
        ? {
            favouriteActive: getLabelFromStorage('favorites.page.remove'),
            favouriteInactive: getLabelFromStorage('favourites.icon.add.accessibility'),
            popupConfirm: getLabelFromStorage('favourites.merge.popup.confirm'),
            close: getLabelFromStorage('general.close'),
            favouriteslimitText: getLabelFromStorage('favorites.page.error.favouriteslimit.description'),
            favouriteslimitTitle: getLabelFromStorage('favorites.page.error.favouriteslimit.title'),
            favouriteErrorText: getLabelFromStorage('favorites.error.text'),
            favouriteErrorTitle: getLabelFromStorage('favorites.error.title'),
            favouriteRemoveError: getLabelFromStorage('favourites.error.remove'),
            checkoutOffersError: getLabelFromStorage('checkout.offers.error'),
        }
        : defaultFavouriteLabels;
    const labels = Object.assign(Object.assign({}, defaultLabels), favouritesLabels);
    const { data: addResponse, execute: addToFavourites, error: addError, } = useRequest('favourites', {
        method: 'post',
        apiVersion: '1',
        manual: true,
        data: { articleCode },
    });
    const { data: removeResponse, execute: removeFromFavourites, error: removeError, } = useRequest(`favourites/${articleCode}`, {
        method: 'delete',
        apiVersion: '1',
        manual: true,
    });
    const handleError = (favouriteState, errorType) => {
        consoleEvents.error(`Error while ${errorType} a Favourite: ${articleCode}`);
        return setIsFavourite(!favouriteState);
    };
    const handleTracking = (response, favouriteState) => {
        var _a, _b;
        const getProductData = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.entries) === null || _b === void 0 ? void 0 : _b.find((entery) => (entery === null || entery === void 0 ? void 0 : entery.articleCode) === articleCode);
        if (getProductData) {
            const getNormalizedTrackingData = normalizeFavouriteTrackingInfo(getProductData);
            return trackFavouriteToggle(getNormalizedTrackingData, articleCode, favouriteState, '', customTrackingData);
        }
        return trackFavouriteToggle(undefined, articleCode, favouriteState, '', customTrackingData);
    };
    const toggleModal = () => {
        setModal(Object.assign(Object.assign({}, modal), { show: false }));
    };
    useEffect(() => {
        if (addResponse) {
            handleTracking(addResponse, isFavourite);
        }
    }, [addResponse]);
    useEffect(() => {
        const favouritesStatus = !!favouritesProducts.find((product) => isCompareArticleIdOnly
            ? (product === null || product === void 0 ? void 0 : product.substring(0, 10)) === (articleCode === null || articleCode === void 0 ? void 0 : articleCode.substring(0, 10))
            : (product === null || product === void 0 ? void 0 : product.substring(0, 10)) === articleCode);
        setIsFavourite(favouritesStatus);
    }, [articleCode, favouritesProducts]);
    useEffect(() => {
        if (isFavouriteSizeVariant) {
            const favouritesStatus = !!favouritesProducts.find((product) => product === articleCode);
            setIsFavourite(favouritesStatus);
        }
    }, [articleCode, isFavouriteSizeVariant, favouritesProducts]);
    useEffect(() => {
        if (removeResponse) {
            handleTracking(removeResponse, isFavourite);
        }
    }, [removeResponse]);
    useEffect(() => {
        var _a, _b;
        if (addError) {
            if (((_b = (_a = addError.response) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.code) === '1004') {
                setModal({
                    show: true,
                    text: labels.favouriteslimitText,
                    title: labels.favouriteslimitTitle,
                });
            }
            else {
                setModal({
                    show: true,
                    text: labels.favouriteErrorText,
                    title: labels.favouriteErrorTitle,
                });
            }
            handleError(isFavourite, 'add');
        }
    }, [addError]);
    useEffect(() => {
        if (removeError) {
            setModal({ show: true, text: labels.favouriteRemoveError, title: labels.favouriteErrorTitle });
            handleError(isFavourite, 'remove');
        }
    }, [removeError]);
    const handleFavouritesClick = () => {
        if (isFavourite) {
            removeFromFavourites();
            if (isArketBrand || isMonkiBrand) {
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish('DECREASE_FAVOURITES_COUNT');
            }
        }
        else {
            addToFavourites();
            if (isArketBrand || isMonkiBrand) {
                appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish('INCREASE_FAVOURITES_COUNT');
            }
        }
        setIsFavourite(!isFavourite);
        onFavouritesClick(!isFavourite, articleCode);
    };
    const handleAltFavouritesClick = (event) => {
        setIsFavourite(!isFavourite);
        onFavouritesClick(!isFavourite, articleCode);
        if (event)
            event.stopPropagation();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: cn(styles.favouriteButton, isFavourite && styles.isFavourite, withBackground && styles.withBackground, shouldOverlay && isFavourite && styles.shouldOverlay, className), onClick: isAltFavouritesClick ? handleAltFavouritesClick : handleFavouritesClick, iconElement: React.createElement(HeartIcon, { size: size }) }, isFavourite ? labels.favouriteActive : labels.favouriteInactive),
        React.createElement(Modal, { closeButtonText: labels.close, title: modal.title, isOpen: modal.show, toggleModal: toggleModal, isModalCompressed: isModalCompressed },
            React.createElement(BodyText, null, modal.text),
            React.createElement(ModalButtons, { bottom: true, fullWidth: true, isModalCompressed: isModalCompressed },
                React.createElement(Button, { onClick: toggleModal }, labels.popupConfirm)))));
};
export default FavouritesButton;
//# sourceMappingURL=FavouritesButton.js.map